import type { ReactNode } from 'react';

import { Outlet } from 'react-router';

import { ProgressiveImage } from '@/components/ui/image';

export interface AuthViewProps {
  children?: ReactNode;
}

export default function AuthView(authViewProps: AuthViewProps) {
  const { children } = authViewProps;
  return (
    <>
      <ProgressiveImage
        alt="Background image"
        className={'absolute inset-0 z-0 opacity-80'}
        sources={{
          mobile: {
            lowRes: {
              webp: '/images/background/auth_bg_img_small.webp',
              jpeg: '/auth_bg/auth_bg_img_small.jpeg',
            },
            highRes: {
              webp: '/images/background/auth_bg_img_medium.webp',
              jpeg: '/images/background/auth_bg_img_medium.jpeg',
            },
          },
          tablet: {
            lowRes: {
              webp: '/images/background/auth_bg_img_medium.webp',
              jpeg: '/images/background/auth_bg_img_medium.jpeg',
            },
            highRes: {
              webp: '/images/background/auth_bg_img_large.webp',
              jpeg: '/images/background/auth_bg_img_large.jpeg',
            },
          },
          desktop: {
            lowRes: {
              webp: '/images/background/auth_bg_img_large.webp',
              jpeg: '/images/background/auth_bg_img_large.jpeg',
            },
            highRes: {
              webp: '/images/background/auth_bg_img_2k.webp',
              jpeg: '/images/background/auth_bg_img_2k.jpeg',
            },
          },
        }}
      />

      <div className={'flex min-h-dvh w-full items-end justify-center p-0 pt-6 md:items-center md:p-6'}>{children ? children : <Outlet />}</div>
    </>
  );
}
